import { defineComponent as _defineComponent } from 'vue'
import type { SingleStepContext } from '@/features/sports/helpers/config';
import type { SingleStepSportEvent } from '@/@types/graphql-types';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { useI18n } from '@/helpers/composables/useI18n';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleStepEventDetails',
  props: {
    context: null,
    event: null,
    kickoffDate: { default: '' }
  },
  setup(__props: any) {

const props = __props as { context: SingleStepContext, event: SingleStepSportEvent, kickoffDate: string };



const { webLocale } = storeToRefs(useLanguageStore());
const { tc } = useI18n();

const rows = computed(() => {
	const filteredRows = [
		{
			key: tc('SPORTS_WEBAPP_KICKOFF_DATE'),
			value: props.kickoffDate,
			icon: `/${ASSETS_DIR}/img/sports/icons/calendar.svg`,
		},
		{
			key: tc('SPORTS_WEBAPP_STADIUM'),
			value: props.event.content?.venue?.name,
			icon: `/${ASSETS_DIR}/img/sports/icons/stadium.svg`,
		},
		{
			key: tc('SPORTS_WEBAPP_COMPETITION'),
			value: props.event?.competition?.content.name,
			icon: `/${ASSETS_DIR}/img/sports/icons/champions_league_cup.svg`,
		},
	].filter(row => row.value);

	const { start, end, isSwitched } = props.context.getCompetitors(props.event, webLocale.value);

	const homeAndAwayCompetitors = [
		{
			key: isSwitched ? tc(`SPORTS_WEBAPP_AWAY_TEAM`) : tc(`SPORTS_WEBAPP_HOME_TEAM`),
			value: start.map(team => team.name).join(' / '),
			icon: `/${ASSETS_DIR}/img/sports/icons/${isSwitched ? 'away_team' : 'home_team'}.svg`,
		},
		{
			key: isSwitched ? tc(`SPORTS_WEBAPP_HOME_TEAM`) : tc(`SPORTS_WEBAPP_AWAY_TEAM`),
			value: end.map(team => team.name).join(' / '),
			icon: `/${ASSETS_DIR}/img/sports/icons/${isSwitched ? 'home_team' : 'away_team'}.svg`,
		},
	];

	return filteredRows.concat(homeAndAwayCompetitors);
});

return { __sfc: true,props, webLocale, tc, rows, HiddenHorizontalScrollbar }
}

})